// extracted by mini-css-extract-plugin
export default {"root":"folder_root__8fLhA","active":"folder_active__8gySi"};